const WALLET_INFO_STORAGE_KEY = 'gw-wallet-info';
const USER_INFO_STORAGE_KEY = 'gw-user-info';
const GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY = 'gw-glipggtoken-data';

export {WALLET_INFO_STORAGE_KEY, USER_INFO_STORAGE_KEY, GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY}
